/* @flow */
import AskForBirthdate from './AskForBirthdate.jsx';
import AskForParentEmail from './AskForParentEmail.jsx';
import AskForRole from './AskForRole.jsx';
import Box from 'components/Box.jsx';
import React from 'react';
import User from 'entities/User';
import { Roles } from 'user/UserConstants';

import './styles/BirthdateModal.scss';

class BirthdateModal extends React.Component {
  static propTypes = {
    user: React.PropTypes.instanceOf(User).isRequired,
  };

  renderDoneCanChat() {
    return this.renderHeader('Thanks!', (
      <span>
        You’re now all set to use Remind.
        We’ve notified everyone that they can now send you messages.
      </span>
    ));
  }

  renderDoneCannotChat() {
    return this.renderHeader('Thanks!', (
      <span>
        Two-way messaging is only available for students 13 and older.
        We’ve notified your teacher. Don’t worry—you will still receive announcements.
      </span>
    ));
  }

  // =======================
  // = Sequence Components =
  // =======================

  renderHeader(title: string, subtext: any) {
    return (
      <div className="BirthdateModal-boxHeader">
        <h2 className="BirthdateModal-boxTitle">{title}</h2>
        <div className="BirthdateModal-boxSubtext">
          {subtext}
        </div>
      </div>
    );
  }

  renderPage() {
    const { user } = this.props;
    const role = user.getRole();
    if (!role) {
      return <AskForRole />;
    }

    if (role === Roles.student) {
      const birthdate = user.getBirthdate();
      if (!birthdate) {
        return <AskForBirthdate />;
      }

      const thirteenYearsAgo = new Date();
      thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear() - 13);
      if (birthdate > thirteenYearsAgo) {
        const parentEmail = user.getParentEmail();
        if (!parentEmail) {
          return <AskForParentEmail />;
        }
        return this.renderDoneCannotChat();
      }
    }

    return this.renderDoneCanChat();
  }

  render() {
    return (
      <Box {...this.props} className="BirthdateModal-box">
        {this.renderPage()}
      </Box>
    );
  }
}

export default BirthdateModal;



// WEBPACK FOOTER //
// ./src/chat/components/BirthdateModal.jsx